<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{title | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <app-modal-loader *ngIf="view.isLoading"></app-modal-loader>

    <div *ngIf="!view.isLoading">

      <div class="alert alert-info">
        <fa-icon [icon]="faInfoCircle"></fa-icon>
        {{'If you update the match criteria it can take up one day to get the correct (re-)calculated match results.' | translate}}
      </div>

      <p>{{'Results' | translate}}: {{view.totalItems}}</p>

      <div class="grid equal-height">

        <div class="row">
          <app-student-card (onClickEvent)="handleClickEvent($event)" class="col-12 col-lg-4 col-md-6 col-sm-6" [data]="item" *ngFor="let item of view.data"></app-student-card>
        </div>

      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="activeModal.close(false)">
        {{'Close' | translate}}
      </button>
    </div>
  </div>
</div>

